module.exports = __webpack_public_path__ + "img/54_17.17a8123e.png";